<template>
  <div class="card">
    <div class="card-header">
      <div>
        <span class="d-inline-block ">{{ $t('object:objectAgencyInfo.retailerInfos') }}</span>
        <span class="d-inline-block ml-2">
          <agency-logo
            :agency-number="agencyid"
            template="AgencyLogoSearch"
          />
        </span>
      </div>
    </div>
    <div class="card-body">
      <button
        class="btn btn-info"
        type="button"
        title="in der Nähe"
        data-ident="searchNeighbours"
        @click="searchNeighbours"
      >
        <i class="icon"><icon-search /></i> {{ $t('object:objectAgencyInfo.searchRadius') }}
      </button>
      <div class="btn btn-info disabled">
        {{ $t('object:objectAgencyInfo.retailer') }}
      </div>
      <div class="btn btn-info disabled">
        {{ $t('object:objectAgencyInfo.agency') }}
      </div>
    </div>
  </div>
</template>
<script>
import AgencyLogo from 'components/AgencyLogo.vue';
import searchRedirect from 'mixins/composition/search/SearchFunctions';

/* ICONS */
import IconSearch from 'ICON:IconSearch';

export default {
  i18nOptions: { namespaces: 'object' },
  components: {
    AgencyLogo,
    IconSearch,
  },
  props: {
    agencyid: {
      type: Number,
      required: true,
    },
    position: {
      type: Object,
      required: false,
      default: () => {},
    },
    travelPersons: {
      type: String,
      required: false,
      default: '2',
    },
    travelStartdate: {
      type: String,
      required: false,
      default: '',
    },
    travelEnddate: {
      type: String,
      required: false,
      default: '',
    },

  },
  setup() {
    return {
      searchRedirect,
    };
  },
  computed: {

  },
  methods: {
    searchNeighbours() {
      const query = {
        latitude: this.position.lat,
        longitude: this.position.lon,
        distance: 50,
        persons: this.travelPersons,
        startDate: this.travelStartdate,
        endDate: this.travelEnddate,
      };
      searchRedirect({ router: this.$router, filters: { ...query } });
    },
  },

};
</script>
